import { BRANDS, browser } from '../common';
import { isForcedMobileCOM } from '../helpers/isForcedMobileCOM';

const YANDEX_METRICA_IDS = {
  CupisDesktop: 92925541,
  CupisMobile: 101877562,
  ComDesktop: 92925936,
  ComMobile: 92926135,
};

export const useSetupMetrics = (brandName) => {
  if (isForcedMobileCOM()) {
    return YANDEX_METRICA_IDS.ComMobile;
  }

  const isMobile = browser().mobile;

  if (brandName === BRANDS.cupis) {
    return isMobile ? YANDEX_METRICA_IDS.CupisMobile : YANDEX_METRICA_IDS.CupisDesktop;
  }

  return isMobile ? YANDEX_METRICA_IDS.ComMobile : YANDEX_METRICA_IDS.ComDesktop;
};
